import * as React from "react";
import { SVGProps } from "react";
const SvgComponent = ({ fill, ...props }: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      fill={fill || "currentColor"}
      fillRule="evenodd"
      d="M4.973 2.293a1 1 0 0 1 1.414 0l16 16a1 1 0 0 1-1.414 1.414l-1.336-1.335c-2.23 1.987-4.97 3.184-7.957 3.184-4.686 0-8.735-2.93-11.212-7.246a3.522 3.522 0 0 1 0-3.508c1.449-2.524 3.428-4.568 5.764-5.836l-1.26-1.259a1 1 0 0 1 0-1.414ZM7.72 6.454c-2.181 1.024-4.105 2.884-5.518 5.344-.27.47-.27 1.047 0 1.517 2.223 3.87 5.691 6.241 9.478 6.241 2.389 0 4.64-.938 6.54-2.601l-2.851-2.852-.004.01a4 4 0 1 1-5.232-5.245L7.72 6.454Zm4.107 4.108a1.998 1.998 0 0 0-2.122 2.31 2 2 0 0 0 3.97-.463l-1.848-1.847Zm2.228-5.772a1 1 0 0 1 1.271-.619c3.122 1.077 5.757 3.482 7.566 6.631.475.828.588 1.8.34 2.695a1 1 0 0 1-1.928-.534 1.522 1.522 0 0 0-.147-1.165c-1.618-2.818-3.906-4.847-6.483-5.736a1 1 0 0 1-.62-1.272Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgComponent;
